// tslint:disable:no-unsafe-any (autogenerated)
import * as React from 'react';
import Radium from '../../../styling/rostelecom-radium';
import Color from 'color';
import InternationalizedComponent from '../../../../../base/internationalized-component';
import { IRostelecomStyleParamsStoreState } from '../../../styling/rostelecom-styles-store';
import { IWindowSizeStoreState } from '../../../../../../services/window-size/window-size-store';

import Loader from '../../../reusable/loader';

export interface ILoginLoaderProps extends React.Props<LoginLoader> {
    styleParams: IRostelecomStyleParamsStoreState;
    windowSize: IWindowSizeStoreState;
    visible: boolean;
}

@Radium
class LoginLoader extends InternationalizedComponent<ILoginLoaderProps, {}> {
    private getStyles(): { [style: string]: React.CSSProperties } {
        const styleParams = this.props.styleParams;
        const loading = this.props.visible;
        const loaderSize = 72;
        return {
            loaderOuter: {
                left: -5,
                top: -5,
                right: -5,
                bottom: -5,
                zIndex: loading ? 100 : 0,
                backgroundColor: Color(styleParams.baseLightColor)
                    .alpha(0.75)
                    .rgbString(),
                opacity: loading ? 1 : 0,
                position: 'absolute',
                pointerEvents: 'none',
                transition: 'opacity .3s ease-out, z-index .3s ease-out'
            },
            loaderInner: {
                position: 'absolute',
                width: loaderSize,
                height: loaderSize,
                top: '50%',
                left: '50%',
                marginTop: -loaderSize / 2,
                marginLeft: -loaderSize / 2
            }
        };
    }

    // tslint:disable-next-line:member-access typedef (autogenerated)
    render() {
        const styles = this.getStyles();
        return (
            <div key="loader" style={styles.loaderOuter}>
                <div key="loaderInner" style={styles.loaderInner}>
                    <Loader styles={this.props.styleParams} />
                </div>
            </div>
        );
    }
}

// tslint:disable-next-line:no-default-export (autogenerated)
export default LoginLoader;
